import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const DeleteConfirmModal = ({ useCase, onClose, onConfirm, isDeleting }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isDeleting) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 modal-backdrop"
      onClick={handleBackdropClick}
      data-testid="delete-confirm-modal"
    >
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-slate-900 font-['Manrope']">
                Delete Use Case
              </h3>
              <p className="text-sm text-slate-500">
                This action cannot be undone.
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-slate-700">
              Are you sure you want to delete <span className="font-semibold">"{useCase?.title}"</span>?
            </p>
            <p className="text-xs text-slate-500 mt-1">
              Client: {useCase?.clientNote}
            </p>
          </div>

          <div className="flex items-center justify-end gap-3">
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              disabled={isDeleting}
              data-testid="delete-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={() => onConfirm(useCase.id)}
              disabled={isDeleting}
              className="bg-red-600 hover:bg-red-700 text-white font-semibold"
              data-testid="delete-confirm-btn"
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
